import React, { useState, useEffect } from "react";
import {
  Button,
  Icon,
  Form,
  Dropdown,
  Label,
  TextArea,
} from "semantic-ui-react";
import "./mdl-delete-critical-unit.css";

export default function MDL_DELETE_CRITICAL_UNIT({
  unitDetails,
  deleteOptions,
  onCancel,
  onSubmit,
}) {
  const [deleteReason, setDeleteReason] = useState(null);
  const [otherReasonText, setOtherReasonText] = useState("");
  const [isOtherSelected, setIsOtherSelected] = useState(false);

  const handleReasonChange = (e, { value }) => {
    const val = value.toLowerCase();
    setDeleteReason(value);
    setIsOtherSelected(val === "other");
    if (val !== "other") {
      setOtherReasonText("");
    }
  };

  const handleSubmit = () => {
    const payload = {
      deleteReason,
      otherReason: isOtherSelected ? otherReasonText : null,
      unitDetails,
    };
    onSubmit(payload);
    onCancel();
  };

  return (
    <>
      {/* Header */}
      <div className="critical-list-modal-header">
        <div className="modal-header-title">Delete Critical Unit</div>

        <div className="modal-header-close" onClick={onCancel}>
          <Icon name="times circle outline" />
        </div>
      </div>

      {/* Content */}
      <div className="critical-list-modal-content">
        <div className="delete-reason-message">
          Are you sure you want to delete unit #{" "}
          {unitDetails?.unit_number || ""} at "
          {unitDetails?.building_address || ""}" for client{" "}
          {unitDetails?.customer_name || ""}?
        </div>

        <Form>
          <Form.Field required>
            <label>Delete Reason</label>
            {/* <Dropdown
              id="delete-reason-dropdown"
              placeholder="Select Delete Reason"
              selection
              options={deleteOptions}
              value={deleteReason ?? ""}
              onChange={handleReasonChange}
            /> */}

            <Dropdown
              id="delete-reason-dropdown"
              placeholder="Select Delete Reason"
              selection
              options={deleteOptions}
              value={deleteReason === "" ? null : deleteReason}
              onChange={handleReasonChange}
              selectOnBlur={false}
            />
          </Form.Field>

          {/* Optional text field appears only when "Other" is selected */}
          {isOtherSelected && (
            <Form.Field required>
              <label>Please specify the reason</label>
              <TextArea
                rows={3}
                placeholder="Please provide reason why this critical unit is being deleted..."
                value={otherReasonText}
                onChange={(e, { value }) => setOtherReasonText(value)}
              />
            </Form.Field>
          )}
        </Form>
      </div>

      {/* Footer */}
      <div className="modal-footer">
        <Button basic color="grey" onClick={onCancel}>
          Cancel
        </Button>

        <Button
          color="red"
          disabled={
            !deleteReason || (isOtherSelected && !otherReasonText.trim())
          }
          onClick={handleSubmit}
        >
          Confirm
        </Button>
      </div>
    </>
  );
}
